import { FC, PropsWithChildren } from 'react';

import MonthName from 'src/components/HumanDate/MonthName';
import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

interface Props {
    value: string;
    fallback: string;
}

const DateInterval: FC<Props & PropsWithChildren> = ({ value, fallback }) => {
    if (!value) {
        return <>{fallback}</>;
    }

    const [year, month] = value.split('-');

    return (
        <>
            <MonthName month={Number(month)} />
            {NON_BREAKING_SPACE}
            {year}
        </>
    );
};

export default DateInterval;
